module.exports = __webpack_public_path__ + "static/media/kare.6c002efb.jpg";